module.exports = "/static/assets/c97dc074c1b113aa15f766ee958ee8c9.png";